<template>
  <div class="container">
    <div class="row ">
      <div class="col-md-4"></div>
      <div class="col-md-4 text-center pt-5 pb-5">
        <div class="font-weight-lighter mb-2">
          SimpleFinance is een product van
          <a class="link" target="_blank" href="https://cisolutions.nl">
            CISolutions
          </a>
        </div>

        <div class="font-weight-lighter">
          © {{ new Date().getFullYear() }} CISolutions
        </div>
      </div>
      <div class="col-md-4 d-flex justify-content-center align-items-center pt-0 pt-md-5 pb-5">
        <a target="_blank" href="https://www.linkedin.com/company/cisolutions">
          <img src="../assets/img/logo-linkedin.svg" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      headerIndex: 1,
    };
  },
  methods: {
    incrementHeader() {
      this.headerIndex += 1;
      setTimeout(this.incrementHeader, 5000);
    },
  },
  created() {
    setTimeout(this.incrementHeader, 5000);
  },
};
</script>

<style scoped>
  a.link {
    text-decoration: none;
    color: #B24592;
  }
</style>
